// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2Msg4","actions":"GroupTable_actions__1cs2P","deleteModalFooter":"GroupTable_deleteModalFooter__2nT7m"};